import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLocationDot,
  faPhone,
  faClock,
} from "@fortawesome/free-solid-svg-icons";
import { useLocations } from "../hooks/useContent";

const LocationCard = ({ title, address, phone, schedule }) => (
  <div className="location-card">
    <h3 className="location-title">{title}</h3>
    <div className="location-details">
      <div className="location-item">
        <FontAwesomeIcon icon={faLocationDot} className="location-icon" />
        <p>{address}</p>
      </div>
      {phone && (
        <div className="location-item">
          <FontAwesomeIcon icon={faPhone} className="location-icon" />
          <p>
            <a href={`tel:${phone}`}>{phone}</a>
          </p>
        </div>
      )}
      {schedule && (
        <div className="location-item">
          <FontAwesomeIcon icon={faClock} className="location-icon" />
          <p>{schedule}</p>
        </div>
      )}
    </div>
  </div>
);

const WhereToFindUs = () => {
  const { locations, loading } = useLocations();

  // Fallback locations for when no locations are configured
  const fallbackLocations = [
    {
      id: 1,
      title: "Centrul Medical Principal",
      address: "Str. Leonte Anastasievici Nr. 11 corp B, București",
      phone: "0725 596 895",
      schedule: "Luni-Vineri: 08:00 – 21:00",
    },
  ];

  // Use dynamic locations if available, otherwise use fallback
  const displayLocations = locations.length > 0 ? locations : fallbackLocations;

  // Determine column classes based on number of locations for responsive design
  const getColumnClass = (totalLocations) => {
    if (totalLocations === 1) return "col-lg-8 col-md-10 col-12 mx-auto";
    if (totalLocations === 2) return "col-lg-6 col-md-6 col-sm-12";
    if (totalLocations === 3) return "col-lg-4 col-md-6 col-sm-12";
    if (totalLocations >= 4) return "col-lg-3 col-md-6 col-sm-12";
    return "col-lg-4 col-md-6 col-sm-12"; // default
  };

  if (loading) {
    return (
      <section className="section locations-section">
        <div className="container">
          <h2 className="section-title">Unde ne puteți găsi</h2>
          <div className="text-center py-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Se încarcă...</span>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section
      className="section locations-section"
      id="locations"
    >
      <div className="container">
        <h2 className="section-title">Unde ne puteți găsi</h2>

        <div className="location-map-container">
          <div className="location-map">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2848.866047857008!2d26.065376851304006!3d44.43590987899974!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40b201801952d2f7%3A0x4959a25917499106!2sAli%20Cranta%20Medical%20Center!5e0!3m2!1sen!2sro!4v1669669163274!5m2!1sen!2sro"
              width="100%"
              height="450"
              style={{ border: 0, borderRadius: "var(--border-radius)" }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Locația centrului medical Ali Cranta"
            ></iframe>
          </div>
        </div>

        <div className="row g-4 mt-5 justify-content-center">
          {displayLocations.map((location) => (
            <div className={getColumnClass(displayLocations.length)} key={location.id}>
              <LocationCard
                title={location.title}
                address={location.address}
                phone={location.phone}
                schedule={location.schedule}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhereToFindUs;
